<template>
  <vue-radial-progress-bar
    :completed-steps="progress === 0 ? 5 : progress"
    :diameter="150"
    :stroke-width="10"
    :total-steps="100"
    inner-stroke-color="transparent"
    start-color="#48bb78"
    stop-color="#48bb78"
    timing-func="cubic-bezier(0, 1.13, 0.77, 0.98)"
  >
    <div class="flex items-baseline">
      <span class="text-4xl">
        <vue-animated-number
          :value="progress"
          :duration="1000"
          :round="1"
          easing="easeOutExpo"
        />
      </span>
      <span class="text-lg">%</span>
    </div>
  </vue-radial-progress-bar>
</template>

<script>
import AnimatedNumber from 'animated-number-vue'
import RadialProgressBar from 'vue-radial-progress'

export default {
  name: 'MiaCarEditOverallProgress',

  components: {
    'vue-animated-number': AnimatedNumber,
    'vue-radial-progress-bar': RadialProgressBar
  },

  props: {
    progress: {
      type: Number,
      required: true
    }
  }
}
</script>
